/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable no-alert */
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import MediaQuery from 'react-responsive';

import RoutedHeader from '../Header';
import NewOpenedAccountBanner from '../NewOpenedAccountBanner';
import accountImage from '../../assets/images/account.png';
import offersImage from '../../assets/images/offers.png';
import investImage from '../../assets/images/invest.png';
import imgHandheldVideo from '../../assets/images/handheldVideo.png';
import imgDownloadIOS from '../../assets/images/downloadIOS.png';
import imgDownloadPlayStore from '../../assets/images/downloadPlayStore.png';

import './index.css';


const MobileHowItWorks = () => (
  <div styleName="howItWorksSectionMobile">
    <div styleName="centeredSectionContainer">
      <div styleName="howItWorksTitle">
        How it works
      </div>
      <div styleName="howItWorksMobile">
        <div styleName="blueLine">
          <div styleName="blueLineTop" />
        </div>
        <div styleName="mobileRow">
          <div styleName="setupDescriptionSection">
            <div styleName="stepNumberMobile">
              1
            </div>
            <div styleName="setupText">
              Set up a My IPO investment account
            </div>
          </div>
          <div styleName="middleSplit" />
          <div styleName="setupImageBoxMobile">
            <img
              src={accountImage}
              alt="Open Account"
              styleName="howImage"
            />
          </div>
        </div>
        <div styleName="mobileRow">
          <div styleName="browseImageBoxMobile">
            <img
              src={offersImage}
              alt="View Offers"
              styleName="howImage"
            />
          </div>
          <div styleName="middleSplit" />
          <div styleName="browseDescriptionSection">
            <div styleName="stepNumberMobile">
              2
            </div>
            <div styleName="browseText">
              Browse My IPO offers
            </div>
          </div>
        </div>
        <div styleName="mobileRow">
          <div styleName="investDescriptionSection">
            <div styleName="stepNumberMobile">
              3
            </div>
            <div styleName="investText">
              Invest in one of the available IPOs or other Offerings<sup>*</sup>
            </div>
          </div>
          <div styleName="middleSplit" />
          <div styleName="investImageBoxMobile">
            <img
              src={investImage}
              alt="invest"
              styleName="howImage"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
);

const DefaultHowItWorks = () => (
  <div styleName="howItWorksSection">
    <div styleName="centeredSectionContainer">
      <div styleName="howItWorksTitle">
        How it works
      </div>
      <div styleName="howItWorks">
        <div styleName="howItWorksBlock">
          <div styleName="descBlock">
            <div styleName="descNum">
              1
            </div>
            <div styleName="descText">
              Set up a My IPO investment account
            </div>
          </div>
          <img
            src={accountImage}
            alt="Open Account"
            styleName="howItWorksImage"
          />
        </div>
        <div styleName="howItWorksBlock">
          <div styleName="descBlock">
            <div styleName="descNum">
              2
            </div>
            <div styleName="descText">
              Browse My IPO offers
            </div>
          </div>
          <img
            src={offersImage}
            alt="View Offers"
            styleName="howItWorksImage"
          />
        </div>
        <div styleName="howItWorksBlock">
          <div styleName="descBlock">
            <div styleName="descNum">
              3
            </div>
            <div styleName="descText">
              Invest in one of the available IPOs or other Offerings<sup>*</sup>
            </div>
          </div>
          <img
            src={investImage}
            alt="Invest"
            styleName="howItWorksImage"
          />
        </div>
      </div>
    </div>
  </div>
);

const MobileStoreBanner = ({ renderMainButton }) => {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  return (
    <div styleName="getStarted">
      <div styleName="getStartedCol">
        <div styleName="getStartedTitle">
        Get started today!
        </div>
        {renderMainButton()}
      </div>
      <div styleName="getStartedCol">
        <div className={{ width: '100%' }}>
          <div style={{ width: '100%', position: 'relative', marginTop: '10px' }}>
            <img src={imgHandheldVideo} alt="Handheld MyIPO Video" style={{ width: '100%' }} />
            <iframe
              title="welcomeVideo"
              src="https://player.vimeo.com/video/402228666"
              frameBorder="0"
              allow="autoplay; fullscreen"
              allowFullScreen
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                marginLeft: '22%',
                marginTop: '11%',
                width: '37%',
                height: '62%',
              }}
            />
          </div>
          <div style={{ width: '100%', textAlign: 'center' }}>
            { isIOS ?
              <a href="https://apps.apple.com/app/my-ipo/id1437751317" target="_blank">
                <img src={imgDownloadIOS} alt="Download on iOS Store" style={{ marginTop: '10px' }} />
              </a> :
              <a href="https://play.google.com/store/apps/details?id=com.myipo.myipo" target="_blank">
                <img src={imgDownloadPlayStore} alt="Download on PlayStore" style={{ marginTop: '10px' }} />
              </a>}
          </div>
        </div>
      </div>
    </div>
  );
};

const DefaultStoreBanner = ({ renderMainButton }) => (
  <div styleName="getStarted">
    <div styleName="getStartedCol">
      <div styleName="getStartedTitle">
        Get started today!
      </div>
      {renderMainButton()}
    </div>
    <div styleName="getStartedCol getStartedBorderLeft">
      <div className={{ width: '100%' }}>
        <div style={{ float: 'left', position: 'relative' }}>
          <img src={imgHandheldVideo} alt="Handheld MyIPO Video" styleName="handheldImage" />
          <iframe
            title="welcomeVideo"
            src="https://player.vimeo.com/video/402228666"
            width="145"
            height="280"
            frameBorder="0"
            allow="autoplay; fullscreen"
            allowFullScreen
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              marginLeft: '90px',
              marginTop: '50px',
            }}
          />
        </div>
        <div style={{ float: 'right' }}>
          <a href="https://apps.apple.com/app/my-ipo/id1437751317" target="_blank">
            <img src={imgDownloadIOS} alt="Download on iOS Store" style={{ display: 'block', marginTop: '172px' }} />
          </a>
          <a href="https://play.google.com/store/apps/details?id=com.myipo.myipo" target="_blank">
            <img src={imgDownloadPlayStore} alt="Download on PlayStore" style={{ display: 'block' }} />
          </a>
        </div>
      </div>
    </div>
  </div>
);

const Home = ({
  authToken,
}) => {
  const btn = {
    text: 'Sign up',
    location: 'https://www.myipo.com/register',
  };
  if (authToken) {
    btn.text = 'View Offers';
    btn.location = '/offers';
  }

  const renderMainButton = () => {
    if (authToken) {
      return (
        <Link styleName="signupBtn" to={btn.location}>
          {btn.text}
        </Link>
      );
    }
    return (
      <Link styleName="signupBtn" to={{ pathname: btn.location }} target="_blank">
        {btn.text}
      </Link>
    );
  };

  return (
    <div styleName="Home">
      <RoutedHeader />
      <MediaQuery maxWidth="624px">
        <NewOpenedAccountBanner isMobile />
      </MediaQuery>
      <MediaQuery minWidth="625px">
        <NewOpenedAccountBanner />
      </MediaQuery>
      <div styleName="levelingSection">
        <div styleName="sectionContainer">
          <div styleName="levelingCTABox">
            <div styleName="levelingTitle">
              Leveling the playing field
            </div>
            <div styleName="levelingSubtitle">
              Giving investors access to some of the most exciting IPOs and other Offerings<sup>*</sup>!
            </div>
            {renderMainButton()}
          </div>
        </div>
      </div>

      <MediaQuery maxWidth="624px">
        <MobileHowItWorks />
        <MobileStoreBanner renderMainButton={renderMainButton} />
      </MediaQuery>
      <MediaQuery minWidth="625px">
        <DefaultHowItWorks />
        <DefaultStoreBanner renderMainButton={renderMainButton} />
      </MediaQuery>
    </div>
  );
};

const mapStateToProps = state => ({
  authToken: state.authToken,
});

export default connect(mapStateToProps)(Home);



// WEBPACK FOOTER //
// ./src/components/Home/index.js